// Middleware de leads Salesforce (UAT). El token OAuth lo resuelve el servicio.
export const SALESFORCE_LEADS_CONFIG = {
  url: process.env.REACT_APP_SALESFORCE_LEADS_URL,
  apiKey: process.env.REACT_APP_SALESFORCE_LEADS_KEY,
  keyHeader: process.env.REACT_APP_SALESFORCE_LEADS_KEY_HEADER || "X-API-Key",
  enabled: process.env.REACT_APP_SALESFORCE_LEADS_ENABLED === "true",
};

export const isSalesforceLeadsEnabled = () => {
  const { enabled, url, apiKey } = SALESFORCE_LEADS_CONFIG;
  return Boolean(enabled && url && apiKey);
};
